import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <motion.a href="https://wa.link/w7hdgn" target="_blank" rel="noopener noreferrer" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: 'spring',
    stiffness: 260,
    damping: 20
  }} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className="fixed bottom-6 right-6 z-40 bg-green-500 hover:bg-green-600 text-white px-6 py-4 rounded-full shadow-2xl flex items-center gap-3 font-bold transition-colors group" data-id="element-158">
      <MessageCircle className="w-6 h-6 group-hover:rotate-12 transition-transform" data-id="element-159" />
      <span className="hidden sm:inline" data-id="element-160">Soporte WhatsApp</span>
    </motion.a>;
}